<template>
    <div class="accounting-document-detail">
        <component
            :queryType="queryType"
            :is="currentComponent"
            :datas="datas"
            :isEditing="isEditing"
            @generate="onGenerate"
            @detail-close="$emit('detail-close', $event)"
            @detail-data-changed="$emit('detail-data-changed')"
            @regenerate-vouchers="$emit('regenerate-vouchers')"
        />
    </div>
</template>

<script>
import AccountingInvoiceDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingInvoiceDetail.vue';
import AccountingPaymentDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingPaymentDetail.vue';
import AccountingVariableStatementDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingVariableStatementDetail.vue';
import AccountingSalaryDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingSalaryDetail.vue';
import AccountingLoanDrawdownDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingLoanDrawdownDetail.vue';
import AccountingLoanRepaymentDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingLoanRepaymentDetail.vue';
import AccountingBankTransferDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingBankTransferDetail.vue';
import AccountingPettyMoneyDetail from '@/components/dashboard/Accounting/AccountingSummary/AccountingDocumentDetail/AccountingPettyMoneyDetail.vue';

export default {
    props: {
        datas: {
            type: Object,
            default: () => {},
        },
        queryType: {
            type: Number,
            default: 0,
        },
        isEditing: Boolean,
    },
    components: {
        AccountingInvoiceDetail,
        AccountingLoanDrawdownDetail,
        AccountingPaymentDetail,
        AccountingSalaryDetail,
        AccountingVariableStatementDetail,
        AccountingLoanRepaymentDetail,
        AccountingBankTransferDetail,
        AccountingPettyMoneyDetail,
    },
    computed: {
        currentComponent() {
            switch (this.queryType) {
            case 1:
                return 'AccountingInvoiceDetail';
            case 2:
                return 'AccountingPaymentDetail';
            case 3:
            case 4:
            case 5:
            case 6:
                return 'AccountingVariableStatementDetail';
            case 7:
                return 'AccountingSalaryDetail';
            case 8:
                if (this.datas.detail?.repaymentList) return 'AccountingLoanDrawdownDetail';
                return 'AccountingLoanRepaymentDetail';
            case 9:
                return 'AccountingBankTransferDetail';
            case 10:
                return 'AccountingPettyMoneyDetail';
            default:
                return '';
            }
        },
    },
    methods: {
        onGenerate(key, data) {
            switch (key) {
            case 'payment':
                this.$emit('generate-payment-voucher', data);
                break;
            case 'reimbursement-invoice':
                this.$emit('generate-reimbursement-invoice-voucher', data);
                break;
            default:
            }
        },
    },
};
</script>

<style lang="scss">
.accounting-document-detail {
    .desc-block {
        font-size: 20px;
        line-height: initial;
        font-weight: bold;
    }
    .fw-b {
        font-weight: bold;
    }
    .space {
        &-l {
            height: 36px;
        }
        &-m {
            height: 24px;
        }
        &-s {
            height: 12px;
        }
    }
    .layout-block {
        display: flex;
    }
}
</style>
